// 把vantul 组件注册抽离出来
import Vue from "vue";
import {
  NavBar,
  Form,
  Field,
  Button,
  Toast,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  List,
  Icon,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  Switch,
  Calendar,
  ActionSheet,
  Checkbox, 
  CheckboxGroup,
  Col, 
  Row,
  Collapse, 
  CollapseItem,
  Sidebar, 
  SidebarItem,
  DatetimePicker,
  Dialog,
  Image as VanImage,
  Search,
  Uploader,
  DropdownMenu, 
  DropdownItem,
  Popup,
  Tag,
  RadioGroup,
  Radio,
} from "vant";

// 使用插件
Vue.use(Tag);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Popup);
Vue.use(NavBar);
Vue.use(Uploader);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Icon);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Switch)
Vue.use(Calendar)
Vue.use(ActionSheet)
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Col);
Vue.use(Row);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(DatetimePicker);
Vue.use(Dialog);
Vue.use(VanImage);



